import Loans from '~/api/loans';

export default {
    getLoanStats({ commit, state, getters }, params) {
        commit('updateLoadingState', {
            loading: 'loans_loading',
            state: true,
        });

        const loanAmountField = params ? params.loan_amount_field : '';

        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/lead/report/loan-stats-json',
                data: {
                    filters: state.loans.params,
                    loan_amount_field: loanAmountField,
                },
                // Purposefully POSTing to handle a larger payload (DEV-24875)
                method: 'POST',
                global: false,
            })
                .done((data) => {
                    commit('updateLoanStats', data);
                    resolve(data);
                    commit('updateLoadingState', {
                        loading: 'loans_loading',
                        state: false,
                    });
                })
                .fail((xhr) => {
                    reject(xhr);
                    commit('updateLoadingState', {
                        loading: 'loans_loading',
                        state: false,
                    });
                });
        });
    },

    deleteLoan({ commit, state }, id) {
        $.ajax({
            url: `/loan/delete/${id}`,
            method: 'GET',
            global: false,
        })
            .done(() => {
                commit('deleteLoan', {
                    id,
                });
                commit('updateLoadingState', {
                    loading: 'loans_loading',
                    state: false,
                });
            })
            .fail(() => {
                commit('updateLoadingState', {
                    loading: 'loans_loading',
                    state: false,
                });
            });
    },

    getLoanFormData({ commit }) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/loan/form-data-json',
                method: 'GET',
                global: false,
            })
                .done((data) => {
                    commit('getLoanFormData', data);
                    resolve(data);
                })
                .fail((xhr) => {
                    reject(xhr);
                });
        });
    },

    getParticipants({ commit, state }, params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/loan/participants',
                method: 'GET',
                data: params,
                global: false,
            })
                .done((data) => {
                    resolve(data);
                })
                .fail((xhr) => {
                    reject(xhr);
                });
        });
    },

    getParticipantRoles({ commit, state }, params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/loan/dt-participants',
                method: 'GET',
                data: {
                    account_class_type: 'LOAN',
                    ...params,
                },
                global: false,
            })
                .done((data) => {
                    commit('updateParticipantRoles', data);
                    resolve(data);
                })
                .fail((xhr) => {
                    reject(xhr);
                });
        });
    },

    async getLoanParticipants({ commit, state }, id) {
        commit('updateLoanParticipantsIsLoading', true);
        const data = await Loans.getLoanParticipants(id);
        commit('updateLoanParticipants', data.participants);
        commit('updateLoanParticipantsIsLoading', false);
        return data;
    },

    async loadPushServices({ state, commit }) {
        if (state.push_services.length !== 0) {
            return;
        }
        try {
            const pushServices = await Loans.getPushServices();
            commit('setPushServices', pushServices);
        } catch (error) {
            return error;
        }
    },

    async sendPushServices({ commit, state, getters }, params) {
        return new Promise((resolve, reject) => {
            const value = { id: params.id, pushTo: params.pushTo };

            $.ajax({
                url: '/loan/push',
                method: 'POST',
                dataType: 'json',
                data: value,
            })
                .done((data) => {
                    resolve(data);
                })
                .fail((xhr) => {
                    reject(xhr);
                });
        });
    },
};
